import type { Category } from 'app/types/category';
import { useAllCategories } from 'app/network/category';

import { Column } from 'app/design/primitives/box';
import { useNavigation } from 'app/hooks/navigation';
import { CategoryPicker } from 'app/screens/new/components/category-picker';

interface CategoryFilterProps {
  value: Category['id'][];
  closeModal: () => void;
  isService: boolean;
}

export function CategoryFilter({ value, closeModal, isService }: CategoryFilterProps) {
  const navigation = useNavigation();

  const { data: categories } = useAllCategories();

  const onPress = () => {
    // Can't show a modal when a bottomSheet is open; close it first, then open the category picker
    closeModal();
    setTimeout(() => {
      if (isService) {
        navigation.navigate(
          'serviceCategories',
          { goBackTo: 'set-atom-then-close', selectedCategory: value[0] },
          { pop: true },
        );
      } else {
        navigation.navigate(
          'categories',
          { goBackTo: 'set-atom-then-close', selectedCategory: value[0] },
          { pop: true },
        );
      }
    }, 300);
  };

  if (!categories) return null;

  return (
    <Column width="100%">
      <CategoryPicker
        goBackTo="set-atom-then-close"
        isService={isService}
        onPress={onPress}
        selectedCategoryId={value[0]}
      />
    </Column>
  );
}
